import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)



export default new Vuex.Store({
	state: {
		login: false,
		gamelist: [],
		isMobile: false,
		userinfo:{}
	},
	getters: {
		login: state => state.login,
		isMobile: state => state.isMobile,
		userinfo: state => state.userinfo,
	

	},
	mutations: {
		SET_login: (state, login) => state.login = login,
		SET_userinfo: (state, userinfo) => state.userinfo = userinfo,
		// 同步异步请求的数据
		setList(state, res) {
			state.gamelist = res;
		},
		SET_IS_MOBILE: (state, isMobile) => state.isMobile = isMobile,


	},
	actions: {

	},
	modules: {}
})